import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Modal } from 'bootstrap';

import { Data2Service } from '../../common/data2.service';
import { DateService } from '../../common/date.service';
import { InfoboxService } from '../../common/infobox/infobox.service';

@Component({
	selector: 'app-bank-account-owners',
	templateUrl: './bank-account-owners.component.html',
	styleUrls: ['./bank-account-owners.component.css'],
})
export class BankAccountOwnersComponent implements OnChanges {
	@Input() ownersTypes: Array<any> = [];
	@Input() users: Array<any> = [];
	@Input() drivers: Array<any> = [];
	@Input() vehicles: Array<any> = [];
	@Input() departments: Array<any> = [];
	@Input() account: any;
	@Output() accountChange = new EventEmitter();
	owners: Array<BankAccountOwner> = [];
	ownersIds: Array<any> = [];
	data: BankAccountOwner = {
		id: null,
		bankAccount: null,
		ownerType: null,
		ownerId: null,
		dateFrom: null,
		dateTo: null,
	};
	isItemBefore = false;
	isItemAfter = false;
	tableRows = [
		{ id: 'ownerTypeName', name: 'Rodzaj' },
		{ id: 'ownerName', name: 'Właściciel' },
		{ id: 'dateFrom', name: 'Data wydania' },
		{ id: 'dateTo', name: 'Data zwrotu' },
	];

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnChanges(): void {
		if (
			!this.account ||
			!this.account.number ||
			!this.ownersTypes ||
			!this.ownersTypes.length ||
			!this.users ||
			!this.users.length ||
			!this.drivers ||
			!this.drivers.length ||
			!this.vehicles ||
			!this.vehicles.length
		) {
			return;
		}
		this.data.bankAccount = this.account.id;
		this.loadData();
	}

	private loadData() {
		this.api.get('/bankAccountsOwners/?bankAccount=' + this.account.id, (result, error) => {
			result.data.forEach((element) => {
				const ownerTypeName = this.ownersTypes.find((obj) => obj.id == element.ownerType);
				element.ownerTypeName = ownerTypeName ? ownerTypeName.name : '??';
				element.ownerName = this.getOwnerName(element.ownerType, element.ownerId);
			});
			this.owners = result.data;
		});
	}

	private getOwnerName(type, id) {
		let object;
		switch (type) {
			case '1': // Pracownicy
				object = this.users.find((obj) => obj.id == id);
				break;
			case '2': // Kierowcy
				object = this.drivers.find((obj) => obj.id == id);
				break;
			case '3': // Auta
				object = this.vehicles.find((obj) => obj.id == id);
				break;
			case '4': // Dzialy
				object = this.departments.find((obj) => obj.id == id);
				break;
			case '5': // TIRy
				object = this.vehicles.find((obj) => obj.id == id);
				break;
		}
		if (!object) {
			return '???';
		}
		return object.name;
	}

	showAdd() {
		this.data = {
			id: null,
			bankAccount: this.account.id,
			ownerType: null,
			ownerId: null,
			dateFrom: this.date.now().date,
			dateTo: null,
		};
		this.isItemAfter = false;
		this.isItemBefore = this.owners.length > 0 ? true : false;
		if (this.isItemBefore) {
			const lastOwner = this.owners[this.owners.length - 1];
			if (!lastOwner.dateTo) {
				this.infobox.error('Uzupełnij datę zwrotu ostatniego właściciela');
				return;
			}
			this.data.dateFrom = this.date.addDays(1, lastOwner.dateTo);
		}
		new Modal(document.getElementById('addModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	submit() {
		// check if dates overlapping
		const lastOwner = this.data.id ? this.owners[this.owners.length - 2] : this.owners[this.owners.length - 1];
		if (lastOwner && (!lastOwner.dateTo || lastOwner.dateTo > this.data.dateFrom)) {
			this.infobox.error('pokrywa');
			return;
		}
		if (this.data.dateTo && this.data.dateTo <= this.data.dateFrom) {
			this.infobox.error('Data zwrotu musi być większa od daty wydania');
			return;
		}
		if (this.data.id) {
			this.update();
			return;
		}
		this.add();
	}

	private add() {
		if (!this.data.dateTo) {
			this.data.dateTo = null;
		}
		this.api.post('/bankAccountsOwners/', this.data, (result, error) => {
			this.data.id = result.data;
			this.loadData();
			this.dialogClose();
		});
	}

	private update() {
		if (!this.data.dateTo) {
			this.data.dateTo = null;
		}
		this.api.put('/bankAccountsOwners/' + this.data.id + '/', this.data, (result, error) => {
			this.loadData();
			this.dialogClose();
		});
	}

	selectOwner(owner) {
		this.data = this.owners.find((obj) => obj.id == owner.id);
		this.ownerTypeSelected();
		const positionInArray = this.owners.indexOf(this.data);
		this.isItemBefore = positionInArray === 0 ? false : true;
		this.isItemAfter = positionInArray === this.owners.length - 1 ? false : true;
		new Modal(document.getElementById('addModal')).show();
	}

	ownerTypeSelected() {
		switch (this.data.ownerType) {
			case '1': // Pracownicy
				this.ownersIds = this.users;
				break;
			case '2': // Kierowcy
				this.ownersIds = this.drivers;
				break;
			case '3': // Auta
				this.ownersIds = this.vehicles.filter(
					(obj) =>
						obj.type.id == 'bus' ||
						obj.type.id == 'autokar' ||
						obj.type.id == 'autokar_flix' ||
						obj.type.id == 'osobowy',
				);
				break;
			case '4': // Dzialy
				this.ownersIds = this.departments;
				break;
			case '5': // TIRy
				this.ownersIds = this.vehicles.filter((obj) => obj.type.id == 'tir');
				break;
		}
	}
}
export interface BankAccountOwner {
	id: number;
	bankAccount: number;
	ownerType: string;
	ownerId: number;
	dateFrom: string;
	dateTo: string;
}
